const lists = [
  [
    "A Boy's Name",
    "U.S. Cities",
    "Things that are Cold",
    "School Supplies",
    "Pro Sports Teams",
    "Insects",
    "Breakfast Foods",
    "Furniture",
    "TV Shows",
    "Things Found in the Ocean",
    "Presidents",
    "Product Names",
  ],
  [
    "Famous Females ",
    "Medicine/Drugs",
    "Things Made of Metal",
    "Hobbies",
    "People in Uniform",
    "Things You Plug in",
    "Animals",
    "Languages",
    "Types of Pasta",
    "Junk Food",
    "Things that Grow",
    "Things at a Pool Party",
  ],
  [
    "Articles of Clothing",
    "Desserts",
    "Car Parts",
    "Things Found on a Map",
    "Athletes",
    "4-Letter Words",
    "Items in a Refrigerator",
    "Farm Animals",
    "Street Names",
    "Things at the Beach",
    "Colors",
    "Tools",
  ],
  [
    "Heroes",
    "Gifts/Presents",
    "Terms of Endearment",
    "Kinds of Dances",
    "Things that are Red",
    "Vehicles",
    "Tropical Locations",
    "College Majors",
    "Dairy Products",
    "Things in a Suvenier Shop",
    "Items in Your Purse/Wallet",
    "World Records",
  ],
  [
    "Sandwiches",
    "Items in a Catalog",
    "World Leaders/Politicians",
    "School Subjects",
    "Excuses for Being Late",
    "Ice Cream Flavors",
    "Things that Jump/Bounce",
    "Television Stars",
    "Things in a Park",
    "Foreign Cities",
    "Stones/Gems",
    "Musicial Instruments",
  ],
  [
    "Nicknames",
    "Things in the Sky",
    "Pizza Toppings",
    "Colleges/Universities",
    "Fish",
    "Countries",
    "Things that Have Spots",
    "Historical Figures",
    "Something You're Afraid Of",
    "Terms of Measurement",
    "Items in the Room You're In",
    "Book Titles",
  ],
  [
    "Fictional Characters",
    "Menu Items",
    "Magazines",
    "Capitals",
    "Kinds of Candy",
    "Items You Save Up To Buy",
    "Footwear",
    "Something You Keep Hidden",
    "Items in a Suitcase",
    "Things with Tails",
    "Sports Equipment",
    "Crimes",
  ],
  [
    "Things that are Sticky",
    "Awards/Ceremonies",
    "Cars",
    "Spices/Herbs",
    "Bad Habits",
    "Cosmetics/Toiletries",
    "Celebrities",
    "Cooking Utensils",
    "Reptiles/Amphibians",
    "Parks",
    "Leisure Activities",
    "Things You Can Be Allergic To",
  ],
  [
    "Restaurants",
    "Notorious People",
    "Fruits",
    "Things in a Medicine Cabinet",
    "Toys",
    "Household Chores",
    "Bodies of Water",
    "Authors",
    "Halloween Costumes",
    "Weapons",
    "Things that are Round",
    "Words Associated with Exercise",
  ],
  [
    "Sports",
    "Song Titles",
    "Parts of the Body",
    "Ethnic Foods",
    "Things You Shout",
    "Birds",
    "A Girl's Name",
    "Ways To Get From Here To There",
    "Items in a Kitchen",
    "Villains/Monsters",
    "Flowers",
    "Things You Replace",
  ],
  [
    "Baby Foods",
    "Famous Duos/Trios",
    "Things Found in/on a Desk",
    "Vacation Spots",
    "Diseases",
    "Words Associated with Money",
    "Items in a Vending Machine",
    "Movie Titles",
    "Games",
    "Things that you Wear",
    "Beers",
    "Things at a Circus",
  ],
  [
    "Vegetables",
    "States",
    "Things You Throw Away",
    "Occupations",
    "Appliances",
    "Cartoon Characters",
    "Types of Drinks",
    "Musical Groups",
    "Store Names",
    "Things at a Football Game",
    "Trees",
    "Personality Traits",
  ],
];

export default lists;
